// src/components/icons/GuitarIcon.js
import React from 'react';

/**
 * GuitarIcon — traced directly from the original icon_guitar_chords.png asset.
 * Uses fill="currentColor" so it inherits the parent element's CSS `color`
 * property, making it fully themeable via --color-buttons.
 */
const GuitarIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 192.923194 204.353119"
    className={className}
  >
    <g
      transform="translate(-32.233608,229.778361) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path d="M1115 2289 c-255 -19 -466 -109 -628 -270 -117 -117 -174 -276 -163 -456 11 -188 111 -482 238 -703 163 -283 355 -519 474 -581 64 -34 66 -28 60 181 -7 224 -18 265 -92 337 -30 29 -54 55 -54 57 0 3 7 34 15 71 22 93 8 108 -52 55 -53 -47 -103 -36 -129 26 -12 30 -12 39 0 69 26 61 103 66 141 9 11 -17 24 -24 38 -22 20 3 22 9 25 79 1 43 -1 99 -5 125 -7 43 -12 49 -35 52 -21 3 -30 -3 -42 -27 -45 -86 -182 -10 -147 82 20 52 92 64 131 22 27 -28 55 -32 67 -10 10 17 -1 157 -17 216 -14 52 -41 52 -74 0 -38 -60 -92 -63 -130 -9 -23 33 -20 75 9 103 31 32 56 31 93 0 36 -30 58 -32 72 -5 8 15 5 33 -15 79 -30 71 -31 94 -8 117 16 16 46 17 399 11 210 -4 389 -9 397 -13 28 -10 29 -41 2 -109 -15 -36 -25 -73 -23 -83 5 -25 44 -27 74 -3 49 39 108 16 120 -45 13 -66 -80 -124 -122 -75 -49 57 -66 72 -77 68 -18 -6 -37 -92 -40 -182 -2 -80 -2 -80 24 -83 18 -2 35 5 53 22 32 33 70 33 101 1 54 -53 16 -145 -59 -145 -34 0 -43 6 -78 49 -20 23 -26 25 -47 12 -15 -10 -35 -200 -25 -233 9 -29 50 -22 74 12 43 61 140 24 140 -53 0 -79 -78 -114 -134 -62 -15 14 -36 25 -48 25 -18 0 -20 -4 -14 -40 21 -132 24 -115 -35 -173 -34 -32 -60 -68 -68 -92 -8 -25 -15 -116 -18 -236 -6 -217 -5 -221 55 -192 81 39 281 274 417 488 174 275 297 624 297 840 -1 222 -87 376 -285 513 -172 119 -316 167 -547 182 -159 11 -149 11 -305 -1z"/>
      <path d="M1023 1818 c-39 -19 -47 -58 -29 -137 31 -134 48 -324 50 -543 1 -198 3 -218 21 -238 28 -31 91 -24 119 13 20 27 21 40 20 230 -2 308 -44 618 -90 664 -25 24 -55 28 -91 11z"/>
      <path d="M1514 1818 c-31 -14 -42 -46 -64 -172 -30 -176 -42 -347 -38 -543 3 -167 5 -184 23 -202 32 -31 85 -31 115 -1 19 19 20 33 20 223 0 202 17 404 46 540 19 94 18 114 -11 142 -25 26 -56 31 -91 13z"/>
    </g>
  </svg>
);

export default GuitarIcon;
